import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Card } from './ui/card';

export const BrandsWeServe = () => {
  const [activeTab, setActiveTab] = useState('bmw');

  const brands = {
    bmw: {
      name: 'BMW',
      logo: 'https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/km2aeqcj_image.png',
      description: 'Expert BMW repair and maintenance services. From routine servicing to complex repairs, our certified technicians handle all BMW models with precision.',
      services: ['Engine Diagnostics', 'Transmission Service', 'Brake System', 'Electrical Systems'],
      link: '/bmw-repair-dubai'
    },
    mercedes: {
      name: 'Mercedes-Benz',
      logo: 'https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/j5clohhg_image.png',
      description: 'Professional Mercedes-Benz repair using genuine parts and STAR diagnostic tools. Specialized in all Mercedes models and AIRMATIC suspension systems.',
      services: ['STAR Diagnostics', '7G-TRONIC Service', 'AIRMATIC Repair', 'Electrical Systems'],
      link: '/mercedes-repair-dubai'
    },
    audi: {
      name: 'Audi',
      logo: 'https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/iakub0i6_image.png',
      description: 'Specialized Audi repair services with VCDS diagnostic tools. Expert Quattro system maintenance and S tronic transmission service.',
      services: ['VCDS Diagnostics', 'Quattro System', 'S tronic Service', 'MMI Repair'],
      link: '/audi-repair-dubai'
    },
    porsche: {
      name: 'Porsche',
      logo: 'https://customer-assets.emergentagent.com/job_think-mechanic/artifacts/1l82b2xy_image.png',
      description: 'Premium Porsche repair and performance tuning. PIWIS diagnostics, PDK transmission service, and PCCB ceramic brake specialists.',
      services: ['PIWIS Diagnostics', 'PDK Service', 'PCCB Brakes', 'Performance Tuning'],
      link: '/porsche-repair-dubai'
    },
    volkswagen: {
      name: 'Volkswagen (VW)',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/eyge2m6x_image.png',
      description: 'Professional Volkswagen repair and maintenance services. Expert diagnostics and repairs for all VW models including Golf, Passat, Tiguan, and more.',
      services: ['Engine Diagnostics', 'DSG Transmission', 'Brake System', 'Electrical Systems'],
      link: '/volkswagen-repair-dubai'
    },
    lamborghini: {
      name: 'Lamborghini',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/h8vevaug_image.png',
      description: 'Exotic Lamborghini repair and maintenance by specialized technicians. Expert care for Huracán, Aventador, and all Lamborghini models with precision and passion.',
      services: ['Performance Diagnostics', 'Engine Service', 'Carbon Ceramic Brakes', 'Suspension Systems'],
      link: '/lamborghini-repair-dubai'
    },
    ferrari: {
      name: 'Ferrari',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/f9o85a5u_image.png',
      description: 'Legendary Ferrari service by passionate specialists. Expert maintenance and repairs for all Ferrari models including 488, F8, SF90, and classic models.',
      services: ['Performance Tuning', 'Engine Diagnostics', 'Carbon Brakes', 'Suspension Service'],
      link: '/ferrari-repair-dubai'
    },
    rollsroyce: {
      name: 'Rolls-Royce',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/3lhj0cbi_image.png',
      description: 'Bespoke Rolls-Royce service with uncompromising luxury care. Expert maintenance for Phantom, Ghost, Cullinan, and all Rolls-Royce models.',
      services: ['Luxury Maintenance', 'Engine Service', 'Air Suspension', 'Interior Care'],
      link: '/rollsroyce-repair-dubai'
    },
    bentley: {
      name: 'Bentley',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/fm0d3efb_image.webp',
      description: 'Exquisite Bentley service combining performance and luxury. Expert care for Continental, Flying Spur, Bentayga, and all Bentley models.',
      services: ['W12 Engine Service', 'Air Suspension', 'Luxury Interiors', 'Performance Tuning'],
      link: '/bentley-repair-dubai'
    },
    landrover: {
      name: 'Land Rover',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/wxnzsu8b_image.png',
      description: 'Specialist Land Rover service for ultimate capability. Expert maintenance for Defender, Range Rover, Discovery, and all Land Rover models.',
      services: ['Terrain Response', 'Air Suspension', 'Engine Diagnostics', '4WD Systems'],
      link: '/landrover-repair-dubai'
    },
    mclaren: {
      name: 'McLaren',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/wiyucfr4_image.png',
      description: 'Elite McLaren service for ultimate performance. Expert maintenance and repairs for 720S, Artura, GT, and all McLaren supercars.',
      services: ['Performance Diagnostics', 'Carbon Fiber Service', 'Hydraulic Systems', 'Track Preparation'],
      link: '/mclaren-repair-dubai'
    },
    astonmartin: {
      name: 'Aston Martin',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/ram4r3z4_image.png',
      description: 'Distinguished Aston Martin service with British excellence. Expert care for DB11, Vantage, DBS, and all Aston Martin grand tourers.',
      services: ['V12 Engine Service', 'Performance Tuning', 'Luxury Interiors', 'Suspension Systems'],
      link: '/astonmartin-repair-dubai'
    },
    jaguar: {
      name: 'Jaguar',
      logo: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_think-mechanic/artifacts/3ftaz172_image.png',
      description: 'Professional Jaguar service with British precision. Expert maintenance for F-Type, F-PACE, XE, XF, and all Jaguar models.',
      services: ['Engine Diagnostics', 'Supercharged V6/V8', 'AWD Systems', 'Performance Service'],
      link: '/jaguar-repair-dubai'
    }
  };

  const activeBrand = brands[activeTab];

  return (
    <section id="brands" className="py-20 bg-gradient-to-br from-zinc-900 via-black to-zinc-900">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">BRANDS WE SERVE</h2>
          <p className="text-gray-400 text-lg">Specialized repair services for German luxury and performance vehicles</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 max-w-4xl mx-auto">
          <div className="bg-white border-2 border-gray-200 rounded-lg p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-red-600 mb-1">15+</div>
            <div className="text-gray-600 text-sm">Years Experience</div>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-lg p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-red-600 mb-1">2000+</div>
            <div className="text-gray-600 text-sm">Cars Serviced</div>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-lg p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-red-600 mb-1">100%</div>
            <div className="text-gray-600 text-sm">Satisfaction</div>
          </div>
          <div className="bg-white border-2 border-gray-200 rounded-lg p-4 text-center shadow-sm">
            <div className="text-2xl font-bold text-red-600 mb-1">13</div>
            <div className="text-gray-600 text-sm">Premium Brands</div>
          </div>
        </div>

        {/* Brand Tabs */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8">
          {Object.keys(brands).map((brandKey) => (
            <button
              key={brandKey}
              onClick={() => setActiveTab(brandKey)}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-3 rounded-lg transition-all duration-200 shadow-lg ${
                activeTab === brandKey
                  ? 'bg-red-600 text-white scale-105 shadow-red-600/50'
                  : 'bg-white text-gray-800 hover:bg-gray-50'
              }`}
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white rounded-full p-1">
                <img
                  src={brands[brandKey].logo}
                  alt={`${brands[brandKey].name} Logo`}
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-semibold text-sm sm:text-base">{brands[brandKey].name}</span>
            </button>
          ))}
        </div>

        {/* Brand Content */}
        <Card className="bg-zinc-800 border-zinc-700 overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 p-8">
            {/* Logo Side */}
            <div className="flex items-center justify-center">
              <div className="w-64 h-64 bg-gray-50 rounded-full flex items-center justify-center shadow-2xl">
                <div className="w-48 h-48">
                  <img
                    src={activeBrand.logo}
                    alt={`${activeBrand.name} Logo`}
                    className="w-full h-full object-contain drop-shadow-2xl"
                    style={{
                      filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.3))'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="flex flex-col justify-center">
              <h3 className="text-3xl font-bold text-white mb-4">{activeBrand.name}</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">{activeBrand.description}</p>
              
              <div className="mb-6">
                <h4 className="text-white font-semibold mb-3">KEY SERVICES:</h4>
                <div className="grid grid-cols-2 gap-3">
                  {activeBrand.services.map((service, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                      <span className="text-gray-300 text-sm">{service}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                {/* WhatsApp CTA Button */}
                <button
                  onClick={() => {
                    const whatsappNumber = '+971566671468';
                    const message = `Hi, I'm interested in ${activeBrand.name} repair services. Can you provide more information?`;
                    const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\+|\s/g, '')}?text=${encodeURIComponent(message)}`;
                    window.open(whatsappUrl, '_blank');
                  }}
                  className="inline-flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 shadow-lg hover:shadow-green-600/50 group"
                >
                  <MessageCircle className="w-5 h-5" />
                  <span>Contact Us on WhatsApp</span>
                </button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};